import { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
import DeliveriesController from 'cio/controllers/deliveries';
import { IdentifierKey } from 'cio/utils/identifiers';
import AuthService from 'cio/services/auth';

export default class DraftsController extends DeliveriesController {
  queryParams = ['actionType', 'startTs', 'endTs'];
  fetchDrafted = true;

  @readOnly(`model.identifiers.${IdentifierKey.CioId}`) personId!: null;

  detailRoute = 'draft.index';
  icon = 'draft';

  @service auth!: AuthService;

  get hasReadOnlyPermission() {
    return !this.auth.hasPermission('journeys/messages/send');
  }
}
